import Vue from "vue";
import Router from "vue-router";
import applyRouterGuard from "./routerGuard";

Vue.use(Router);

import newsRoutes from "./routes.news";
import healthRoutes from "./routes.health";
import analyticsRoutesV1 from "./routes.analytics.v1";
import analyticsRoutesV2 from "./routes.analytics.v2";

const routerConfig = {
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...newsRoutes,
    ...healthRoutes,
    ...analyticsRoutesV1,
    ...analyticsRoutesV2,
    {
      path: "*",
      component: () => import("$views/Errors/NotFoundPage"),
    },
  ],
};
const router = new Router(routerConfig);

// 라우터 가드 적용
applyRouterGuard(router);

export default router;
